import React from "react";
import Paragraph from "../components/Paragraph";
import Col from "../components/Col";
import SubHeadline from "../components/SubHeadline";
import Strong from "../components/Strong";
import List from "../components/List";

export default () => (
  <Col>
    <SubHeadline>
      MEIN <Strong>STACK</Strong>
    </SubHeadline>
    <List>
      <List.ListItem>Typescript</List.ListItem>
      <List.ListItem>Javascript, EcmaScript2015+</List.ListItem>
      <List.ListItem>React</List.ListItem>
      <List.ListItem>Next.js</List.ListItem>
      <List.ListItem>Angular (8+)</List.ListItem>
      <List.ListItem>Redux</List.ListItem>
      <List.ListItem>Webpack</List.ListItem>
      <List.ListItem>
        CSS3+, SASS, PostCSS, CSS-Modules + CSS-in-JS
      </List.ListItem>
      <List.ListItem>Unit-Testing mit Jest, Jasmine und Mocha</List.ListItem>
      <List.ListItem>ESLint, StyleLint, Prettier, Lint-Staged</List.ListItem>
      <List.ListItem>GraphQL, Apollo</List.ListItem>
      <List.ListItem>a11y</List.ListItem>
      <List.ListItem>RxJs</List.ListItem>
      <List.ListItem>NestJS</List.ListItem>
      <List.ListItem>Flutter</List.ListItem>
      <List.ListItem>ServiceWorker, Workbox</List.ListItem>
      <List.ListItem>OAuth2, OpenID Connect</List.ListItem>
      <List.ListItem>10 Jahre SCRUM Erfahrung</List.ListItem>
      <List.ListItem>Sicherer Umgang mit Photoshop, Illustrator, Sketch und Figma</List.ListItem>
      <List.ListItem>Erfahrung Symfony, Ruby on Rails und Express</List.ListItem>
      <List.ListItem>Git</List.ListItem>
      <List.ListItem>Containerisierung mit Docker und Kubernetes</List.ListItem>
    </List>
  </Col>
);



// WEBPACK FOOTER //
// ./src/components/Tech.js